export const getPlayerActionsText = (used, limit) => {
  return `${used} / ${limit}`
}